import { getThemeId } from '../selectors/getThemeId';
import { getThemeMode } from '../selectors/getThemeMode';
import { isSystemDark } from './isSystemDark';
import { loadTheme } from './loadTheme';
import { logUsage } from 'owa-analytics';
import { THEME_MODE_SYSTEM_DARK, THEME_MODE_SYSTEM_LIGHT } from '../constants/constants';
import { ThemeMode } from '../schema/ThemeMode';

export const systemThemeChangeHandler = () => {
    const themeId = getThemeId();
    const themeMode = getThemeMode();
    // Refresh only if we are dependent on browser's dark mode preference
    if (themeMode === ThemeMode.System) {
        loadTheme(themeId, themeMode);
        const isCurrentSystemDark = isSystemDark();
        const newAppearance = isCurrentSystemDark
            ? THEME_MODE_SYSTEM_DARK
            : THEME_MODE_SYSTEM_LIGHT;
        const prevAppearance = isCurrentSystemDark
            ? THEME_MODE_SYSTEM_LIGHT
            : THEME_MODE_SYSTEM_DARK;

        logUsage('changeThemeMode', {
            prevVal: prevAppearance,
            newVal: newAppearance,
            source: 'System',
        });
    }
};
